import React, {useState, useRef} from 'react'
import {useSelector} from 'react-redux';
import BudgetSurrender from '../../components/BudgetSurrender/BudgetSurrender';
import CreateButton from '../../components/Tools/CreateButton';
import SubHeader from '../../components/Subheader/Subheader';


export default function BudgetSurrenderList() {
    const {financialYears,authData} = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('approval_date');
    const [searchStr, setToSearchStr] = useState('');


    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <BudgetSurrender fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr} approved={true} title={"Budget Surrender"}/>
            </div>
            { authData.user.user_type === 'l1' && <CreateButton title={"Add Budget Surrender"} url={"/add-budget-surrender"}/> }
        </div>
    )
}